import { defineStore } from 'pinia'
import { ref } from 'vue'
import { removeLocalCache } from '@/utils/cache'

export const useEnvStore = defineStore(
  'useEnvStore',
  () => {
    const env = ref('')
    const setEnv = (value) => {
      env.value = value
    }

    const getEnv = () => {
      return env.value
    }

    const isWechatMiniprogram = () => {
      return env.value === 'mp'
    }

    const isApp = () => {
      return env.value === 'app'
    }

    const isWeb = () => {
      return env.value === 'js'
    }

    const removeAll = () => {
      env.value = null
      removeLocalCache('env')
    }

    return { env, setEnv, getEnv, isWechatMiniprogram, isApp, isWeb, removeAll }
  },
  {
    // 添加持久化配置
    persist: true,
  },
)
